import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
import React from 'react';
import Button, { ButtonColor, ButtonVariant } from '../button/Button';
import * as styles from './ConfirmBox.style';
const DEFAULT_CONFIRM_LABEL = 'OK';
const DEFAULT_ABORT_LABEL = 'Annulla';
const ConfirmBox = _ref => {
  let {
    title,
    description,
    confirmLabel,
    abortLabel,
    onConfirm,
    onAbort,
    dataRef = 'confirm-box',
    'aria-label': ariaLabel = 'confirm-box'
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-ref": dataRef,
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement(_StyledH, {
    $_css: styles.title
  }, title), description && /*#__PURE__*/React.createElement(_StyledP, {
    $_css2: styles.description
  }, description), /*#__PURE__*/React.createElement(_StyledFooter, {
    $_css3: styles.footer
  }, /*#__PURE__*/React.createElement(Button, {
    label: confirmLabel || DEFAULT_CONFIRM_LABEL,
    color: ButtonColor.SECONDARY,
    dataRef: `${dataRef}-confirm`,
    onClick: onConfirm
  }), /*#__PURE__*/React.createElement(Button, {
    label: abortLabel || DEFAULT_ABORT_LABEL,
    color: ButtonColor.NEUTRAL,
    variant: ButtonVariant.OUTLINE,
    dataRef: `${dataRef}-abort`,
    onClick: onAbort
  })));
};
export default ConfirmBox;
var _StyledH = _styled("h2").withConfig({
  displayName: "ConfirmBox___StyledH",
  componentId: "sc-iv2w2k-0"
})(["", ""], p => p.$_css);
var _StyledP = _styled("p").withConfig({
  displayName: "ConfirmBox___StyledP",
  componentId: "sc-iv2w2k-1"
})(["", ""], p => p.$_css2);
var _StyledFooter = _styled("footer").withConfig({
  displayName: "ConfirmBox___StyledFooter",
  componentId: "sc-iv2w2k-2"
})(["", ""], p => p.$_css3);
//# sourceMappingURL=ConfirmBox.js.map